import type { EventName } from "@lit/react";
import { LoginForm as LoginFormElement, type LoginFormEventMap as _LoginFormEventMap, } from "@vaadin/login/vaadin-login-form.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { LoginFormElement, };
export type LoginFormEventMap = Readonly<{
    onDisabledChanged: EventName<_LoginFormEventMap["disabled-changed"]>;
    onErrorChanged: EventName<_LoginFormEventMap["error-changed"]>;
    onForgotPassword: EventName<_LoginFormEventMap["forgot-password"]>;
    onLogin: EventName<_LoginFormEventMap["login"]>;
}>;
const events = { onDisabledChanged: "disabled-changed", onErrorChanged: "error-changed", onForgotPassword: "forgot-password", onLogin: "login" } as LoginFormEventMap;
export type LoginFormProps = WebComponentProps<LoginFormElement, LoginFormEventMap>;
export const LoginForm = createComponent({
    elementClass: LoginFormElement, events, react: React, tagName: "vaadin-login-form"
});
